export const ROLE_COLORS: Record<string, string> = {
  supports: "#1D9E75",
  challenges: "#D85A30",
  extends: "#378ADD",
  applies: "#639922",
  operationalises: "#5DCAA5",
  reviews: "#7F77DD",
};

export const READING_OPACITY: Record<string, number> = {
  read: 0.93,
  skimmed: 0.55,
  unread: 0.36,
};

export const READING_OPACITY_DARK: Record<string, number> = {
  read: 0.95,
  skimmed: 0.62,
  unread: 0.45,
};

export const EVIDENCE_COLORS: Record<string, string> = {
  supports: "#1D9E75",
  challenges: "#D85A30",
  qualifies: "#BA7517",
};
